function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling?.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });
  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  let money_format = "{{ shop.money_format }}";
  let formatString = format || money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    let parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (window.productBuffer != null && window.productBuffer != undefined) {
      let totalProducts =
        Number(window.productBuffer.quantity) -
        Number(window.productBuffer.buffer);

      if (
        Number(previousValue) < totalProducts &&
        event.target.name === "plus"
      ) {
        this.input.stepUp();
      } else if (event.target.name === "minus") {
        this.input.stepDown();
      }
    } else {
      event.target.name === "plus"
        ? this.input.stepUp()
        : this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class dynamicPrice extends HTMLElement {
  constructor(onLoad = true) {
    super();
    if (onLoad) {
      this.btnEventListeners();
      // this.updatePriceWithoutVariants();
    }
  }

  btnEventListeners() {
    const { sleevePatch } = this.priceComponents();

    if (sleevePatch != null || sleevePatch != undefined) {
      sleevePatch.addEventListener("click", () => {
        this.updatePriceWithoutVariants();
      });
    }
  }

  updatePriceWithoutVariants() {
    const { regularPrice, salePrice, currencySymbol, priceInfo } =
      this.priceComponents();
    let totalProductPrice =
      Number(priceInfo.dataset.price) + Number(this.checkCustomSleevePatch());

    if (
      priceInfo.dataset.comparePrice != null ||
      priceInfo.dataset.comparePrice != undefined
    ) {
      let totalComparePrice =
        Number(priceInfo.dataset.comparePrice) +
        Number(this.checkCustomSleevePatch());
      salePrice.querySelector(".prov-price-main-product-sale").textContent =
        currencySymbol + totalProductPrice.toFixed(2);
      salePrice.querySelector(
        ".prov-price-main-product-sale-before"
      ).textContent = currencySymbol + totalComparePrice.toFixed(2);
    } else {
      //price__regular prov-price-main-product
      regularPrice.querySelector(".price-item").textContent =
        currencySymbol + totalProductPrice.toFixed(2);
    }
  }

  updatePriceVariantChange(priceDetails) {
    const { currencySymbol } = this.priceComponents();
    const saleContainer = priceDetails.querySelector(".price__sale");

    //Product on sale price
    let salePriceContainer = saleContainer.querySelector(
      ".prov-price-main-product-sale"
    );

    if (
      priceDetails.querySelector(".prov-price-main-product-sale-before").dataset
        .price != ""
    ) {
      let regularPriceContainer = saleContainer.querySelector(
        ".prov-price-main-product-sale-before"
      );
      let totalPrice =
        Number(regularPriceContainer.dataset.price) +
        Number(this.checkCustomSleevePatch());
      let totalSalePrice =
        Number(salePriceContainer.dataset.price) +
        Number(this.checkCustomSleevePatch());

      regularPriceContainer.textContent =
        currencySymbol + totalPrice.toFixed(2);
      salePriceContainer.textContent =
        currencySymbol + totalSalePrice.toFixed(2);
    } else {
      let regularPriceContainer = priceDetails.querySelector(
        ".price__container .prov-price-main-product"
      );
      let totalPrice =
        Number(
          regularPriceContainer.querySelector(".price-item").dataset.price
        ) + Number(this.checkCustomSleevePatch());
      regularPriceContainer.querySelector(".price-item").textContent =
        currencySymbol + totalPrice.toFixed(2);
    }
  }

  checkCustomSleevePatch() {
    let sleevePatch = document.getElementById("custom-product-sleeve");
    let flamingoSleevePatch = document.getElementById(
      "flamongo-product-sleeve"
    );
    let customPrint = document.querySelector(
      ".product-custom-print-dropdown-btn"
    );
    let total = 0;

    //Check sleeve patch price if present
    if (sleevePatch != null || sleevePatch != undefined) {
      if (
        sleevePatch.checked &&
        !sleevePatch.parentElement.classList.contains("hidden")
      ) {
        total += Number(sleevePatch.dataset.price);
      }
    }

    //Check flamingo patch price if present
    if (flamingoSleevePatch != null || flamingoSleevePatch != undefined) {
      if (
        flamingoSleevePatch.checked &&
        !flamingoSleevePatch.parentElement.classList.contains("hidden")
      ) {
        total += Number(flamingoSleevePatch.dataset.price);
      }
    }

    if (customPrint != null || customPrint != undefined) {
      total += Number(customPrint.dataset.price);
    }
    return total;
  }

  priceComponents() {
    const price = this.querySelector(".price");
    const sleevePatch = document.getElementById("custom-product-sleeve");
    const regularPrice = document.querySelector(
      ".prov-price-container .price__regular"
    );
    const salePrice = document.querySelector(".price__sale");
    const currencySymbol = document.getElementById("cart-currency-symbol")
      .dataset.symbol;
    const customPrint = document.querySelector(
      ".product-custom-print-dropdown-btn"
    );
    const priceInfo = document.getElementById("dynamic-price-product-info");

    return {
      price,
      sleevePatch,
      regularPrice,
      salePrice,
      currencySymbol,
      customPrint,
      priceInfo,
    };
  }
}

customElements.define("dynamic-price", dynamicPrice);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelector("#close_button").addEventListener(
      "click",
      this.onCloseButtonClick.bind(this)
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    // this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.slidesPerPage = Math.round(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    // --CUSTOM SHIRT CODE--
    this.customPrintInputText = this.querySelector("#custom-print-text");
    this.customPrintInputNumber = this.querySelector("#custom-print-number");
    this.sleevePatchInput = this.querySelector("#custom-product-sleeve");
    this.flamingoSleevePatchInput = this.querySelector(
      "#flamongo-product-sleeve"
    );
    this.customPrintSelect = this.querySelector(
      ".product-custom-print-options"
    );

    this.productDynamicPrice = new dynamicPrice(false);

    if (this.customPrintInputText) {
      this.customPrintInputText.addEventListener(
        "input",
        this.updateCustomPrintForm.bind(this)
      );
      this.customPrintInputNumber.addEventListener(
        "input",
        this.updateCustomPrintForm.bind(this)
      );
      this.customPrintSelect.addEventListener(
        "click",
        this.updateCustomPrintForm.bind(this)
      );
      this.sleevePatchInput.addEventListener(
        "click",
        this.updateSleevePatchForm.bind(this)
      );
      this.flamingoSleevePatchInput.addEventListener(
        "click",
        this.updateSleevePatchForm.bind(this)
      );
    }

    // ---PRODUCT INITIALS---
    this.productInitialsInput = this.querySelector("#product-initials");
    if (this.productInitialsInput) {
      this.productInitialsInput.addEventListener(
        "input",
        this.updateFormWithProductInitials.bind(this)
      );
    }

    const url = new URL(window.location);
    const metaTagVariantId = document.querySelector(
      '[name="shopify:variant:id"]'
    );

    if (metaTagVariantId && url.searchParams.has("variant")) {
      const variantId = metaTagVariantId.getAttribute("content");
      url.searchParams.set("variant", variantId);
      window.history.replaceState({}, "", url);
    }

    window.productBuffer = null;
    this.updateOptions();
    this.updateMasterId();
    this.updateBufferQuantity();
  }

  updateFormWithProductInitials(event) {
    if (
      !this.validCustomPrintTextInput(event) ||
      this.productInitialsInput.value.length < 1
    )
      return;
    const initials = this.productInitialsInput.value;

    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const initialsInputEl = productForm.querySelector("#product-initials");
      if (!initialsInputEl) {
        const newInputEl = document.createElement("input");
        newInputEl.name = "properties[Initials]";
        newInputEl.value = initials;
        newInputEl.type = "hidden";
        newInputEl.id = "product-initials";
        productForm.appendChild(newInputEl);
      } else {
        initialsInputEl.value = initials;
      }
    });
  }

  validCustomPrintTextInput(event) {
    const target = event.currentTarget;
    // Invalid input
    if (
      target.value.length > 0 &&
      !target.value.charAt(target.value.length - 1).match(/[A-Za-z\-.'\s]/i)
    ) {
      target.value = target.value.slice(0, target.value.length - 1);
      return false;
    }
    return true;
  }

  validCustomPrintNumberInput(event) {
    const target = event.currentTarget;
    // Max 2 digits
    if (target.value.length > target.maxLength) {
      target.value = target.value.slice(0, target.maxLength);
      return false;
    }
    // Only allow numbers to be entered
    if (target.value.length > 0) {
      const isNumber = /^\d$/.test(
        target.value.charAt(target.value.length - 1)
      );
      if (!isNumber) {
        target.value = target.value.slice(
          target.value.length - 2,
          target.value.length - 1
        );
        return false;
      }
    }
    return true;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    //this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateBufferQuantity();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  getBufferDetails() {
    let currentID = this.currentVariant.id;
    let allBuffers = document.getElementById("all-product-buffers");

    if (allBuffers != null) {
      const variantBufferData = allBuffers.querySelector(
        `#variant-${currentID}`
      );
      return {
        quantity: Number(variantBufferData.dataset.quantity),
        buffer: Number(variantBufferData.dataset.buffer),
      };
    } else {
      console.error("Variant not found!");
      return null;
    }
  }

  updateBufferQuantity() {
    if (this.currentVariant.inventory_management !== null) {
      window.productBuffer = this.getBufferDetails();
    } else {
      window.productBuffer = null;
    }
  }

  checkBufferAvailability() {
    let disableButton =
      window.productBuffer.quantity <= window.productBuffer.buffer;
    this.toggleAddButton(disableButton, window.variantStrings.soldOut);
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      let equal = true;
      this.options.forEach((opt) => {
        if (!variant.options.includes(opt)) {
          equal = false;
        }
      });
      return equal;
    });

    let variantSleeveData = document.getElementById(
      `variant-sleeve-${this.currentVariant.id}`
    );
    let sleeveContainer = document.getElementById("product-sleeve-patch");

    let flamingoVariantSleeveData = document.getElementById(
      `flamingo-variant-sleeve-${this.currentVariant.id}`
    );
    let flamingoSleeveContainer = document.getElementById(
      "flamingo-sleeve-patch"
    );

    this.setSleeveVisibility(variantSleeveData, sleeveContainer);
    this.setSleeveVisibility(
      flamingoVariantSleeveData,
      flamingoSleeveContainer
    );
  }

  setSleeveVisibility(sleeveData, sleeveContainer) {
    if (sleeveData != null && sleeveContainer != null) {
      let sleeveState = sleeveData.dataset.state;
      if (sleeveState === "true") {
        sleeveContainer.classList.remove("hidden");
      } else {
        sleeveContainer.classList.add("hidden");
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      false
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateSleevePatchForm(e) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );

    if (e.target.checked) {
      productForms.forEach((productForm) => {
        const newTextInputEl = document.createElement("input");
        newTextInputEl.type = "hidden";
        if (e.target.name == "flamongo-product-sleeve") {
          newTextInputEl.name = "properties[Flamingo patch]";
          newTextInputEl.dataset.productid = e.target.dataset.productid;
        } else {
          newTextInputEl.name = "properties[Sleeve patch]";
        }
        newTextInputEl.name =
          e.target.name == "flamongo-product-sleeve"
            ? "properties[Flamingo patch]"
            : "properties[Sleeve patch]";
        newTextInputEl.value = "True";
        productForm.appendChild(newTextInputEl);
      });
    } else {
      productForms.forEach((productForm) => {
        const sleevePatchInput =
          e.target.name == "flamongo-product-sleeve"
            ? productForm.querySelector(
                'input[name="properties[Flamingo patch]"]'
              )
            : productForm.querySelector(
                'input[name="properties[Sleeve patch]"]'
              );
        if (!sleevePatchInput) return;
        sleevePatchInput.remove();
      });
    }
  }

  // --CUSTOM SHIRT CODE--
  updateCustomPrintForm(e) {
    if (e.target.classList.contains("product-custom-print-options")) return;

    if (
      window.innerWidth < 750 &&
      !e.target.classList.contains("custom-print-option") &&
      e.target.tagName !== "INPUT"
    )
      this.showMobilePrint();

    if (e.target.tagName !== "INPUT") {
      this.clearFormInputs();
      this.customPrintInputText.value = "";
      this.customPrintInputNumber.value = "";
      this.querySelector('[aria-selected="true"]').setAttribute(
        "aria-selected",
        false
      );
      e.target.setAttribute("aria-selected", true);

      this.querySelector(".product-custom-print-dropdown-btn").setAttribute(
        "aria-expanded",
        false
      );
      this.querySelector(".product-custom-print-options").setAttribute(
        "aria-hidden",
        true
      );
      this.querySelector(".product-custom-print-dropdown-btn").dataset.price =
        e.target.dataset.price != undefined ? e.target.dataset.price : 0;
      this.productDynamicPrice.updatePriceWithoutVariants();
      this.querySelector(
        ".product-custom-print-dropdown-btn span"
      ).textContent = e.target.textContent;

      if (!e.target.classList.contains(".custom-print-option")) {
        this.querySelector(
          ".product-custom-print-user-input-container"
        ).setAttribute("aria-hidden", true);
      }

      if (e.target.classList.contains("no-custom-print-option")) {
        this.clearDigitSvg();
        this.clearCharacterSvg();
        return;
      }

      if (
        e.target.classList.contains("custom-print-option") &&
        this.querySelector(
          ".product-custom-print-user-input-container"
        ).getAttribute("aria-hidden") !== "false"
      ) {
        this.querySelector(
          ".product-custom-print-user-input-container"
        ).setAttribute("aria-hidden", false);
      }
    }

    if (
      e.target.id === "custom-print-text" &&
      !this.validCustomPrintTextInput(e)
    )
      return;
    if (
      e.target.id === "custom-print-number" &&
      !this.validCustomPrintNumberInput(e)
    )
      return;
    if (e.target.classList.contains("custom-print-option")) return;

    const customText = this.customPrintInputText.value;
    const customNumber = this.customPrintInputNumber.value;
    const dropDownOptionValue = e.target.dataset.value;
    const dropDownOptionId = this.querySelector('button[aria-selected="true"]')
      .dataset.variantId;

    const shirtPrint =
      e.target.tagName !== "INPUT"
        ? dropDownOptionValue
        : `${customText} ${customNumber}`;

    this.renderInputSvg(shirtPrint);

    // Custom print inputs not filled, return to avoid form input creation
    if (
      (customText.length < 1 || customNumber.length < 1) &&
      e.target.tagName === "INPUT"
    ) {
      this.clearFormInputs();
      return;
    }

    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const customPrintFormInput = productForm.querySelector(
        'input[name="properties[Shirt printing]"]'
      );
      const customPrintFormIDInput = productForm.querySelector(
        'input[name="properties[Shirt print id]"]'
      );
      if (!customPrintFormInput) {
        const newTextInputEl = document.createElement("input");
        newTextInputEl.type = "hidden";
        newTextInputEl.name = "properties[Shirt printing]";
        newTextInputEl.value =
          shirtPrint.length > 0 ? shirtPrint : "ERROR: PRINT NOT SUBMITTED";
        productForm.appendChild(newTextInputEl);
      } else if (customPrintFormInput) {
        customPrintFormInput.value =
          shirtPrint.length > 0 ? shirtPrint : "ERROR:  PRINT NOT SUBMITTED";
      }

      if (!customPrintFormIDInput) {
        const customPrintVariantId = document.createElement("input");
        customPrintVariantId.type = "hidden";
        customPrintVariantId.name = "properties[Shirt print id]";
        customPrintVariantId.value = dropDownOptionId;
        productForm.appendChild(customPrintVariantId);
      } else if (customPrintFormIDInput) {
        customPrintFormIDInput.value = dropDownOptionId;
      }
    });
    this.updateVariantInput();
  }

  clearFormInputs() {
    document
      .querySelectorAll('input[name="properties[Shirt printing]"]')
      .forEach((el) => el.remove());
    document
      .querySelectorAll('input[name="properties[Shirt print id]"]')
      .forEach((el) => el.remove());
  }

  renderInputSvg(shirtPrint) {
    const { text, digits } = this.parseShirtPrint(shirtPrint);
    const productImageUl = document.querySelector(".prov-product-media");
    const mainImgLi = productImageUl.querySelector("li:nth-child(1)");
    const newImgLi = productImageUl.querySelector("li:nth-child(3)");
    const clone = newImgLi.cloneNode(true);
    mainImgLi.remove();
    productImageUl.prepend(clone);
    clone
      .querySelector(".product-custom-print-overlay")
      .classList.remove("product-custom-print-overlay-small");

    const textOverlayContainer = document.querySelector(
      ".product-custom-print-text"
    );
    const numberOverlayContainer = document.querySelector(
      ".product-custom-print-digits"
    );

    const currentImgChars = Array.from(
      textOverlayContainer.querySelectorAll("img")
    ).map((img) => {
      return img.dataset.value;
    });
    const currentImgDigits = Array.from(
      numberOverlayContainer.querySelectorAll("img")
    ).map((img) => {
      return img.dataset.value;
    });

    // User deleted all characters, clear img elements
    if (!text && currentImgChars.length > 0) {
      this.clearCharacterSvg();
    }

    if (!digits && currentImgDigits.length > 0) {
      this.clearDigitSvg();
    }

    if (text && this.arraysDoNotMatch(text, currentImgChars)) {
      this.clearCharacterSvg();
      text.forEach((letter) => {
        this.addSvgChar(letter);
      });
    }

    if (digits && this.arraysDoNotMatch(digits, currentImgDigits)) {
      this.clearDigitSvg();
      digits.forEach((digit) => {
        this.addSvgDigit(digit);
      });
    }
  }

  parseShirtPrint(text) {
    const n = /[0-9]/g;
    const t = /[a-zA-Z\-.'\s]/g;
    const trimmedText = text.trim();

    let textMatch = trimmedText.match(t);
    let digitMatch = trimmedText.match(n);

    if (textMatch) {
      textMatch = textMatch.join("").trim().match(t);
    }

    return {
      text: textMatch,
      digits: digitMatch,
    };
  }

  addSvgChar(value, index) {
    const textOverlayContainers = document.querySelectorAll('.product-custom-print-text');
    textOverlayContainers.forEach((cont) => {
      if (value === ' ') {
        value = 'letter_space';
      }
      const newImg = this.createSvgImg(value);
      cont.insertBefore(newImg, cont.children[index]);
    });
  }

  addSvgDigit(value, index) {
    const numberOverlayContainers = document.querySelectorAll(
      ".product-custom-print-digits"
    );
    numberOverlayContainers.forEach((cont) => {
      const newImg = this.createSvgImg(value);
      cont.insertBefore(newImg, cont.children[index]);
    });
  }

  clearCharacterSvg() {
    const textOverlayContainers = document.querySelectorAll(
      ".product-custom-print-text"
    );
    textOverlayContainers.forEach((cont) => {
      while (cont.hasChildNodes()) {
        cont.removeChild(cont.firstChild);
      }
    });
  }

  clearDigitSvg() {
    const numberOverlayContainers = document.querySelectorAll(
      ".product-custom-print-digits"
    );
    numberOverlayContainers.forEach((cont) => {
      while (cont.hasChildNodes()) {
        cont.removeChild(cont.firstChild);
      }
    });
  }

  createSvgImg(value) {
    const regex = /(.*\/).*.*svg/; // Gets file url without svg file
    let char;
    switch (value) {
      case "'":
        char = "apostrophe";
        break;
      case "-":
        char = "dash";
        break;
      case " ":
        char = "space";
        break;
      case ".":
        char = "period";
        break;
      default:
        char = value;
    }
    // custom_print_colour and print_svg_url come from main-product.liquid
    let fileUrl = `${print_svg_url
      .match(regex)
      .filter((el) => !el.includes("svg"))
      .toString()}${char.toLowerCase()}_${custom_print_colour}.svg`;

    if (char === "letter_space") {
      fileUrl = `${print_svg_url
        .match(regex)
        .filter((el) => !el.includes("svg"))
        .toString()}letter_space.svg`;
    }

    const newImg = document.createElement("img");
    newImg.setAttribute("src", fileUrl);
    newImg.setAttribute("data-value", value);
    if (char === "apostrophe") {
      newImg.classList.add("product-custom-print-apostrophe");
    } else if (char.toLowerCase() === "q") {
      newImg.classList.add("product-custom-print-q");
    } else if (char === "dash") {
      newImg.classList.add("product-custom-print-dash");
    }
    return newImg;
  }

  arraysDoNotMatch(arr1, arr2) {
    if (arr1?.length !== arr2?.length || arr1.join("") !== arr2.join(""))
      return true;
    return false;
  }

  showMobilePrint() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    document.querySelector(".product__media-list").scrollTo({ left: 400 });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        const productQuantity = html.getElementById("product-quantity");

        let productBuffer = document.getElementById("product-buffer");
        productBuffer.innerHTML = "";
        productBuffer.appendChild(productQuantity);

        if (productQuantity != null && productQuantity.dataset.buffer != null) {
          this.checkBufferAvailability();
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }

        if (price) {
          price.classList.remove("visibility-hidden");

          this.productDynamicPrice.updatePriceVariantChange(price);
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      if (document.getElementById("customise-button") != null) {
        document
          .getElementById("customise-button")
          .setAttribute("disabled", "disabled");
      }
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    const options = [];

    fieldsets.map((fieldset) => {
      fieldset.querySelectorAll("input").forEach((input) => {
        if (input.checked) {
          options.push(input.value);
        }
      });
    });
    this.options = options;
  }
}

customElements.define("variant-radios", VariantRadios);

class AccordionElement extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector(".accordion__content");
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    //Open the accordion if the dataset is set to open
    if (this.dataset.open === "true") {
      this.details.open = true;
    }

    this.details
      .querySelector("summary")
      .addEventListener("click", this.openContent.bind(this));
  }

  openContent(e) {
    // Prevent the default <details> element animation from playing
    e.preventDefault();
    this.details.style.overflow = "hidden";
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.details.open) {
      this.open();
      // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }

  shrink() {
    if ((this.dataset.titleColour = true))
      this.querySelector(".accordion__title").classList.toggle(
        "menu-item-title-color"
      );

    // Set the element as "being closed"
    this.isClosing = true;
    this.details.style.overflow = "hidden";
    // Store the current height of the element
    const startHeight = `${this.details.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.details.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 600,
        easing: "cubic-bezier(.37,.54,.06,1.13)",
      }
    );

    this.content.classList.add("prov-full-opacity");
    this.querySelector(".icon-plus").classList.add("prov-no-opacity");

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => {
      this.onAnimationFinish(false);
      this.content.classList.remove("prov-full-opacity");
      this.querySelector(".icon-plus").classList.remove("prov-no-opacity");
    };
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => {
      this.isClosing = false;
      this.content.classList.remove("prov-full-opacity");
      this.querySelector(".icon-plus").classList.remove("prov-no-opacity");
    };
  }

  open() {
    if ((this.dataset.titleColour = true))
      this.querySelector(".accordion__title").classList.toggle(
        "menu-item-title-color"
      );
    // Apply a fixed height on the element
    this.details.style.height = `${this.details.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.details.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    const allAccordionEls =
      this.details.parentElement.parentElement.querySelectorAll(
        "accordion-element"
      );
    // Shrink all other accordion-elements that are not current one
    for (let x = 0; x < allAccordionEls.length; x++) {
      const d = allAccordionEls[x].querySelector("details");
      if (d !== this.details && d.open === true) {
        allAccordionEls[x].shrink();
      }
    }
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.details.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.details.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 600,
        easing: "cubic-bezier(.37,.54,.06,1.13)",
      }
    );
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.details.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.details.style.height = this.details.style.overflow = "";
  }
}

customElements.define("accordion-element", AccordionElement);

class ProductGallerySlider extends HTMLElement {
  constructor() {
    super();
    this.slides = this.querySelectorAll(".collection-product-container");
    this.slidePercentage = 130;
    this.positionSlides();
    this.positionSliderBtn();
    this.querySelector(".btn-container").addEventListener(
      "click",
      this.slide.bind(this)
    );
    this.querySelector(".btn-container").addEventListener(
      "click",
      this.positionSliderBtn.bind(this)
    );
    window.addEventListener("resize", this.positionSliderBtn.bind(this));
  }

  positionSlides() {
    this.slides.forEach((element) => {
      if (element.hidden) {
        element.style.transform = `translateX(${
          this.slidePercentage * (element.dataset.collection - 1)
        }%)`;
      }
    });
  }

  positionSliderBtn() {
    const btnSlider = this.querySelector(".btn-slider");
    const activeBtn = this.querySelector('button[aria-current="true"]');
    btnSlider.style.left = activeBtn.offsetLeft + "px";
    btnSlider.style.width = activeBtn.offsetWidth + "px";
  }

  slide(e) {
    const btnNum = e.target.dataset.btnCollection;
    if (this.slideCurrentlyShowning(btnNum)) return;
    this.setActiveButton(btnNum);
    this.slides.forEach((element) => {
      const elCollectionNum = element.dataset.collection;
      const transformBy = (btnNum - elCollectionNum) * this.slidePercentage;
      if (elCollectionNum === btnNum) {
        element.style.transform = `translateX(0%)`;
        element.removeAttribute("hidden");
      } else if (elCollectionNum < btnNum) {
        element.style.transform = `translateX(${transformBy * -1}%)`;
        element.setAttribute("hidden", "");
      } else {
        element.style.transform = `translateX(${transformBy * -1}%)`;
        element.setAttribute("hidden", "");
      }
    });
  }

  slideCurrentlyShowning(slideNum) {
    return !this.querySelector(`[data-collection='${slideNum}']`).hidden;
  }

  setActiveButton(btnNum) {
    this.querySelectorAll("button").forEach((btn) => {
      if (btn.dataset.btnCollection === btnNum) {
        btn.setAttribute("aria-current", true);
      } else {
        btn.removeAttribute("aria-current");
      }
    });
  }
}

customElements.define("product-gallery-slider", ProductGallerySlider);

class TabletSearchMenu extends HTMLElement {
  constructor() {
    super();
    this.searchButton = this.querySelector("button");
    this.searchButton.addEventListener(
      "click",
      this.searchMenuClick.bind(this)
    );
    this.searchFormContainer = this.querySelector(".search-div-tablet__form");
  }

  searchMenuClick(e) {
    if (this.searchFormContainer.hasAttribute("aria-hidden")) {
      this.searchFormContainer.removeAttribute("aria-hidden");
      this.querySelector(".search-div-tablet-underline").removeAttribute(
        "aria-hidden"
      );
    } else if (this.querySelector("input").value.length > 0) {
      this.querySelector("form").submit();
    } else {
      this.searchFormContainer.setAttribute("aria-hidden", "true");
      this.querySelector(".search-div-tablet-underline").setAttribute(
        "aria-hidden",
        "true"
      );
    }
  }
}

customElements.define("prov-search-menu", TabletSearchMenu);

class HeaderDropDownMenu extends HTMLElement {
  constructor() {
    super();
    this.initiateListeners();
    window.addEventListener("resize", (e) => {
      this.querySelectorAll('[aria-expanded="true"]').forEach((el) => {
        this.resizeContentContainer(el)
      })
    })
    // this.setProductTitleHeights() 
  }

  initiateListeners() {
    const headerDropDownEl = this.querySelectorAll(".header-dropdown");
    headerDropDownEl.forEach((btn) => {
      btn.addEventListener("mouseenter", (event) => {
        if (
          this.isAriaExpanded(
            event.currentTarget.querySelector(".header-submenu-div")
          )
        )
          return;
        this.showContent(event);
      });

      btn.addEventListener("click", (event) => {
        if (
          this.isAriaExpanded(
            event.currentTarget.querySelector(".header-submenu-div")
          )
        ) {
          this.hideContent(event);
        } else {
          this.showContent(event);
        }
      });

      btn.addEventListener("mouseleave", (event) => {
        if (
          event.relatedTarget.classList.contains("header-submenu-div") ||
          !this.isAriaExpanded(
            event.currentTarget.querySelector(".header-submenu-div")
          )
        )
          return;
        this.hideContent(event);
      });

      btn.parentElement
        .querySelector(".header-submenu-div")
        .addEventListener("mouseleave", (event) => {
          event.currentTarget.setAttribute("aria-expanded", false);
          event.currentTarget.previousElementSibling.setAttribute(
            "aria-pressed",
            false
          );
        });
    });
  }

  isAriaExpanded(element) {
    return element.getAttribute("aria-expanded") === "true";
  }

  showContent(event) {
    const button = event.currentTarget.querySelector("button");
    if (button.dataset.contentOpening) return;
    this.closeOpenedDropDowns(event);
    const buttonRelatedContent = button.nextElementSibling;
    buttonRelatedContent.setAttribute("aria-expanded", true);
    button.setAttribute("data-content-opening", true);
    button.setAttribute("aria-pressed", true);
    this.resizeContentContainer(buttonRelatedContent);
    setTimeout(() => {
      if (button.hasAttribute("data-content-opening")) {
        button.removeAttribute("data-content-opening");
      }
    }, 100);
  }

  hideContent(event) {
    const button = event.currentTarget.querySelector("button");
    if (button.dataset.contentOpening) return;
    const buttonRelatedContent = button.nextElementSibling;
    button.setAttribute("aria-pressed", false);
    buttonRelatedContent.setAttribute("aria-expanded", false);
    buttonRelatedContent.style.height = 0 + "px";
  }

  closeOpenedDropDowns(event) {
    // This function is just there in case
    const currDropDown = event.currentTarget.querySelector(
      ".header-submenu-div"
    );
    const openedDropDowns = document.querySelectorAll(".header-submenu-div");
    openedDropDowns.forEach((el) => {
      if (el === currDropDown) return;
      el.setAttribute("aria-expanded", false);
      el.previousElementSibling.setAttribute("aria-pressed", false);
    });
  }

  resizeContentContainer(element) {
    // if (window.innerWidth <= 990) {
    //   element.style.height = element.scrollHeight+'px';
    //   element.querySelector('.submenu-collection').style.height = element.scrollHeight+'px';
    // } else {
    //   element.style.height = "310px";
    //   element.querySelector('.submenu-collection').style.height = '310px';
    // }
    element.style.height = element.scrollHeight + "px";
    element.querySelector(".submenu-collection").style.height =
      element.scrollHeight - 200 + "px";

    // this.setProductTitleHeights()
  }

  setProductTitleHeights() {
    const collectionGrids = this.querySelectorAll(".submenu-collection ul");
    collectionGrids.forEach((collection) => {
      const collectionTitles = collection.querySelectorAll(
        ".submenu-product-title"
      );
      if (collectionTitles.length < 1) return;
      const largestTitle = Array.from(collectionTitles).reduce(
        (highestEl, curElement) => {
          if (
            highestEl.style.height < curElement.style.height ||
            curElement.style.height !== "auto"
          ) {
            return curElement;
          } else {
            return highestEl;
          }
        }
      );

      largestTitle.style.height = "auto";

      if (largestTitle.offsetHeight < 1) {
        const otherLargestT = Array.from(collectionTitles).reduce(
          (highestEl, curElement) => {
            curElement.style.height = "max-content";
            if (highestEl.offsetHeight < curElement.offsetHeight) {
              return curElement;
            } else {
              return highestEl;
            }
          }
        );
        collectionTitles.forEach((el) => {
          if (el !== otherLargestT)
            el.style.height = otherLargestT.offsetHeight + "px";
        });
        return;
      }

      collectionTitles.forEach((el) => {
        if (el !== largestTitle)
          el.style.height = largestTitle.offsetHeight + "px";
      });
    });
  }
}

customElements.define("header-dropdown-menu", HeaderDropDownMenu);

class MobileNav extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(".menu-drawer-item-btn").forEach((btn) => {
      btn.addEventListener("click", (event) => {
        const btnEl = event.currentTarget;
        const btnPressed = btnEl.getAttribute("aria-pressed") === "true";
        btnEl.setAttribute("aria-pressed", !btnPressed);
        const contentWrapper = btnEl.parentElement.querySelector(
          ".menu-drawer-item-content-wrapper"
        );
        contentWrapper.setAttribute("aria-hidden", btnPressed);
        if (!btnPressed) {
          contentWrapper.style.maxHeight =
            btnEl.parentElement.querySelector(".menu-drawer-item-content")
              .offsetHeight + "px";
        } else {
          contentWrapper.style.maxHeight = 0 + "px";
        }
      });
    });
  }
}

customElements.define("mobile-nav", MobileNav);
